import React from 'react';
import { Lightbulb, Camera, Wand2, Shield, Package, CameraIcon, Send } from 'lucide-react';
import { services, stats, workflowSteps } from '../data/mock';

const iconMap = {
  Lightbulb,
  Camera,
  Wand2,
  Shield,
};

const workflowIcons = [Package, CameraIcon, Send];

const ServicesSection = () => {
  return (
    <section id="services" data-testid="services-section" className="py-12 lg:py-20 relative">
      {/* Background */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/2 left-0 w-80 h-80 bg-[#d987ff]/4 rounded-full blur-[100px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-10 lg:mb-14">
          <span className="inline-block px-4 py-1.5 bg-white/[0.04] border border-white/[0.08] rounded-full text-sm text-gray-400 mb-4 lg:mb-5 tracking-wide">
            Leistungen
          </span>
          <h2 className="text-2xl lg:text-4xl font-bold mb-4 lg:mb-5 text-white">
            Von der Idee zum
            <span className="text-gradient"> finalen Visual</span>
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Von der ersten Stilrichtung bis zum fertig ausgearbeiteten Visual begleiten wir den 
            gesamten Prozess – markengerecht, effizient und auf kommerzielle Nutzung ausgelegt.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                data-testid={`service-card-${service.id}`}
                className="group relative p-6 rounded-2xl bg-white/[0.02] border border-white/[0.06] transition-all duration-200 hover:bg-white/[0.04] hover:border-[#ff84e4]/20"
              >
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#ff84e4]/15 to-[#d987ff]/15 flex items-center justify-center mb-5">
                  <IconComponent className="w-6 h-6 text-[#ff84e4]" />
                </div>
                <span className="absolute top-4 right-5 text-5xl font-bold text-white/[0.03]">
                  0{index + 1}
                </span>
                <h3 className="text-base font-semibold mb-2 text-white">{service.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{service.description}</p>
              </div>
            );
          })}
        </div>

        {/* Workflow Section */}
        <div className="mt-12 lg:mt-16">
          <h3 className="text-lg lg:text-2xl font-bold mb-6 lg:mb-8 text-center text-white">
            So läuft die Zusammenarbeit ab
          </h3>
          <div className="grid md:grid-cols-3 gap-5">
            {workflowSteps.map((step, index) => {
              const IconComponent = workflowIcons[index];
              return (
                <div
                  key={step.id}
                  data-testid={`workflow-step-${step.id}`}
                  className="relative p-6 rounded-2xl bg-white/[0.02] border border-white/[0.06]"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-xl bg-[#d987ff]/10 flex items-center justify-center flex-shrink-0">
                      <IconComponent className="w-5 h-5 text-[#d987ff]" />
                    </div>
                    <span className="text-xs font-bold text-[#d987ff]/60 tracking-widest">{step.step}</span>
                  </div>
                  <h4 className="text-base font-semibold text-white mb-2">{step.title}</h4>
                  <p className="text-gray-500 text-sm leading-relaxed">{step.description}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Stats Section */}
        <div className="mt-10 lg:mt-14 p-5 lg:p-8 rounded-2xl bg-white/[0.02] border border-white/[0.06]">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            {stats.map((stat, index) => (
              <div key={index} data-testid={`stat-${index}`}>
                <div className="text-2xl lg:text-3xl font-bold text-[#ff84e4] mb-1">{stat.value}</div>
                <p className="text-white font-medium text-sm mb-1">{stat.label}</p>
                <p className="text-gray-500 text-xs">{stat.sublabel}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
